import {pipe, keys, map, join, split, filter, fromPairs} from 'ramda';

// Return only a local path: parsing a URL and then using the raw input is unsafe.
export const normalizeLoginRedirect = (value, baseUrl = window.location.href) => {
	if (value == null) return null;
	if (
		typeof value !== 'string' ||
		!value ||
		value !== value.trim() ||
		value.startsWith('//') ||
		// eslint-disable-next-line no-control-regex -- Reject URL-parser control characters.
		/[\u0000-\u001f\u007f\\]/.test(value) ||
		/%(?![0-9a-f]{2})/i.test(value)
	) {
		return '/';
	}

	try {
		const base = new URL(baseUrl);
		const target = new URL(value, base);
		if (
			!['http:', 'https:'].includes(target.protocol) ||
			target.origin !== base.origin ||
			target.username ||
			target.password
		) {
			return '/';
		}

		const path = `${target.pathname}${target.search}${target.hash}`;
		// Dot-segment normalization can turn /a/..//host into //host.
		return path.startsWith('//') || new URL(path, base).origin !== base.origin
			? '/'
			: path;
	} catch {
		return '/';
	}
};

export const encodeQuery = obj =>
	pipe(
		keys,
		map(k => `${k}=${obj[k] != null ? encodeURIComponent(obj[k]) : ''}`),
		join('&'),
		str => (str.length ? `?${str}` : str),
	)(obj);

export const decodeQuery = pipe(
	str => (str.length ? str.substring(1) : str),
	split('&'),
	filter(x => x !== ''),
	map(pipe(split('='), map(decodeURIComponent))),
	fromPairs,
);

export const createReferrerUrl = location => {
	const {pathname, search, hash} = location;
	return `${pathname}${search}${hash}`;
};

export const getReferrerUrl = query => {
	const {referrerUrl} = decodeQuery(query);
	if (!referrerUrl) {
		return null;
	}
	return referrerUrl;
};

export const getReferrer = query => {
	const {referrer} = decodeQuery(query);
	if (!referrer) {
		return null;
	}
	return referrer;
};

export const getDisableReturn = query => {
	const {disableReturn} = decodeQuery(query);
	if (disableReturn === 'true') return true;
	return false;
};
